/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from "react";
import CompleteADIQuestionnaire from "../../components/questionnaire/CompleteADIQuestionnaire";

const CompleteADIQuestionnaireWrapper: FC = () => {
  useEffect(() => {
    document.title = `ADI Network App | Questionnaire | ADI Network`;
  }, []);

  return (
    <>
      <div className="mb-20">
        <CompleteADIQuestionnaire />
      </div>
    </>
  );
};

export { CompleteADIQuestionnaireWrapper };
